module.exports = __webpack_public_path__ + "img/30600.546e261d.jpg";